import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import {
  debounceTime, distinctUntilChanged, switchMap
} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

import { PrescriptionPrint } from '../../print/prescription.print';

import { PrescriptionTemplate } from '../prescription-template';
import { PrescriptionTemplateService } from '../../service/prescription-template.service';
import { Prescription } from '../../prescription/prescription';

@Component({
  selector: 'mc-prescription-template-index',
  templateUrl: './prescription-template-index.component.html',
  styleUrls: ['./prescription-template-index.component.scss']
})
export class PrescriptionTemplateIndexComponent implements OnInit {

  editIcon = faEdit;

  public templates: PrescriptionTemplate[];
  private searchTerms = new Subject<string>();
  prescribing: boolean = false;
  private prescription: Prescription;
  @Input() public crudMode: boolean = true;
  @Output() selected: EventEmitter<PrescriptionTemplate> = new EventEmitter<PrescriptionTemplate>();

  constructor(
    private ptService: PrescriptionTemplateService,
    private notifService: ToastrService,
    private prescriptionPrint: PrescriptionPrint
  ) { }

  ngOnInit() {
    this.searchTerms.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term: string) => this.ptService.searchPrescriptionTemplateByName(term))
    ).subscribe(
      templates => this.templates = templates,
      error => this.notifService.error(error)
    );
  }

  search(term: string): void {
    if (term.length < 3) { return; }
    this.searchTerms.next(term);
  }

  selectedTemplate(template: PrescriptionTemplate): void {
    this.selected.emit(template);
  }

  startPrescribing(): void {
    this.prescription = new Prescription();
    this.prescription.date = new Date();
    this.prescribing = true;
  }

  onPrescribingCanceled(): void {
    this.prescribing = false;
  }

  onPrinted(prescription: Prescription): void {
    this.prescriptionPrint.execute(null, prescription);
  }
}
